import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import logoff from '../modules/auth/actions/logoff';
import '../styles/app.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  static propTypes = {
    children: PropTypes.object.isRequired,
    onNavigate: PropTypes.func.isRequired,
    onLogoff: PropTypes.func.isRequired
  };

  handleToggle = () => this.setState({ open: !this.state.open });

  handleClose = () => this.setState({ open: false });

  handleMenuNavigation = path => () => {
    this.handleClose();
    this.props.onNavigate(path);
  };

  handleLogoff = () => {
    this.handleClose();
    this.props.onLogoff();
  };

  render() {
    return (
      <div>
        <AppBar
          title="Mentalist"
          iconElementLeft={
            <IconButton onClick={this.handleToggle}>
              <NavigationMenu />
            </IconButton>
          }
        />
        <div style={{ margin: '1em' }}>{this.props.children}</div>
        <Drawer
          docked={false}
          width={200}
          open={this.state.open}
          onRequestChange={open => this.setState({ open })}
        >
          <MenuItem onClick={this.handleMenuNavigation('/')}>Home</MenuItem>
          <MenuItem onClick={this.handleMenuNavigation('/sessions/new')}>
            New scouting session
          </MenuItem>
          <Divider />
          <MenuItem onClick={this.handleMenuNavigation('/sessions')}>
            Scouting sessions
          </MenuItem>
          <MenuItem onClick={this.handleMenuNavigation('/players')}>
            Players
          </MenuItem>
          <MenuItem onClick={this.handleMenuNavigation('/games')}>
            Games
          </MenuItem>
          <MenuItem onClick={this.handleMenuNavigation('/positions')}>
            Positions
          </MenuItem>
          <Divider />
          <MenuItem onClick={this.handleMenuNavigation('/organizations')}>
            Organizations
          </MenuItem>
          <Divider />
          <MenuItem onClick={this.handleLogoff}>Log off</MenuItem>
        </Drawer>
      </div>
    );
  }
}

const mapDispatchers = dispatch => {
  return {
    onNavigate: url => dispatch(push(url)),
    onLogoff: () => dispatch(logoff)
  };
};

export default connect(null, mapDispatchers)(App);



// WEBPACK FOOTER //
// ./src/components/App.js